//@ts-ignore: Unreachable code error
import hmacSHA256 from 'crypto-js/hmac-sha256';
//@ts-ignore: Unreachable code error
import { stringify } from 'crypto-js/enc-hex';
import { PRIVATE_KEY } from '../constants/env';


const ALLOW_KEYS = [
    'ctime',
    'id',
    'type',
    'listType',
    'listId',
    'page',
    'size',
    'version',
];

export function buildSig(path: string, params: object): string {
    const message = buildMessage(params);
    const hmacDigest = hmacSHA256(path + message, PRIVATE_KEY);
    return stringify(hmacDigest);
}

function buildMessage(params: any): string {
    const sortParams: any = sortObject(params);
    const _params: any = [];
    for (let key in sortParams) {
        if (ALLOW_KEYS.indexOf(key) === -1) {
            continue;
        }

        if (
            params[key] === null ||
            params[key] === undefined ||
            params[key] === ''
        ) {
            continue;
        }
        _params[key] = sortParams[key];
    }
    return buildQuery(_params, '');
}

const sortObject = (obj: any) => {
    const ordered: any = {};
    Object.keys(obj)
        .sort()
        .forEach(function (key) {
            ordered[key] = obj[key];
        });
    return ordered;
};

const buildQuery = (params: any, separator = '&') => {
    const esc = encodeURIComponent;
    return Object.keys(params)
        .map((k) =>
            esc(params[k]).length > 5000 ? '' : `${esc(k)}=${esc(params[k])}`
        )
        .filter((k) => k !== '')
        .join(separator);
};
